import { rem } from 'polished'
import styled from 'styled-components'

interface IDragDropWrapperStyledProps {}

export const DragDropWrapperStyled = styled.div<IDragDropWrapperStyledProps>`
  font-size: ${rem(16)};
  position: relative;
`
